import { GET, PATCH, POST } from "../../helper/xbi4RestFunctions";

export const getUserEPto = async (org_id: any, org_user_id: any) => {
  const path = `/orgs/${org_id}/users/${org_user_id}/emergency_pto`;
  return await GET(path)
    .then((result) => {
      return result[1];
    })
    .catch((err) => {
      console.log("error on fetching objective >", err);
      return err;
    });
};
